/* A function to disable the back and next navigation in the browser */

import history from '../../history';

function disableBrowserNavigation() {
	var currentPathname = null;
	var currentSearch = null;

	var callback = function( newLocation, action ) {
		if ( action === 'PUSH' ) {
			if (
				newLocation.pathname !== currentPathname
				|| newLocation.search !== currentSearch
			) {
				// Save new location
				currentPathname = newLocation.pathname;
				currentSearch = newLocation.search;
				// Clone location object and push it to history
				history.push( {
					pathname: newLocation.pathname,
					search: newLocation.search
				} );
			}
		} else {
			// Send user back if they try to navigate back
			history.go( 1 );
		}
	};

	history.listen( callback );
}

export default disableBrowserNavigation;
